import { env } from "@/config/env"

const LOVE_MATCH_PDF_FILENAME = "Live Palmistry - Relationship Truths Report.pdf"

export function downloadLoveMatchReport(): void {
  const link = document.createElement("a")
  link.href = encodeURI(env.VITE_LOVE_MATCH_PDF_URL)
  link.download = LOVE_MATCH_PDF_FILENAME
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

/** Label for a purchased report's CTA. Every report opens in-app on tap (the
 *  email-delivered astrology report shows its PDF in the viewer too), so it's
 *  always "View". */
export function getPurchasedReportLabel(): string {
  return "View"
}
